import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

export default function Level3() {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.check}`}>
        <MainIcons.CheckedIcon fill="var(--green)" width={'42px'} height="42px" strokeWidth="2.4" />
      </div>
      <div className={`${styles.title}`}>با موفقیت وارد شدید</div>
      <p className={`${styles.text}`}>
        اکنون می‌توانید خلافی خودرو و کاربران زیرمجموعه را مدیریت کنید.
      </p>
    </div>
  );
}
